import { render, staticRenderFns } from "./RoomBoardCard.vue?vue&type=template&id=d19e5edc&scoped=true&"
import script from "./RoomBoardCard.vue?vue&type=script&lang=js&"
export * from "./RoomBoardCard.vue?vue&type=script&lang=js&"
import style0 from "./RoomBoardCard.vue?vue&type=style&index=0&id=d19e5edc&lang=scss&scoped=true&"
import style1 from "./RoomBoardCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19e5edc",
  null
  
)

export default component.exports